module.exports = __webpack_public_path__ + "static/media/bkWallDelivery.d2c7a914.svg";